import classNames from 'classnames';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import SiteLink from '../sitelink/sitelink';
import Icon from '../icon';
import styles from './button.module.scss';

const Button = ({ button, locale, className, onClick }) => {
  const router = useRouter();
  const { link, externalLink, title, pageReload, style, color, customColor, customTextColor } =
    button || {};

  // const isWhiteWithBlackText = color === 'White with black text';
  const isBlackWithWhiteText = color === 'Black with white text';

  const getTextColor = () => {
    if (customTextColor) return customTextColor;
    if (isBlackWithWhiteText) return '#ffffff';
    return '#000000';
  };

  const getBackgroundColor = () => {
    if (customColor) return customColor;
    if (isBlackWithWhiteText) return '#000000';
    return '#ffffff';
  };

  const getHoverTextColor = () => {
    if (customTextColor) return '#ffffff'; // in case of custom colors, on hover button becomes black with white text
    if (isBlackWithWhiteText) return '#000000';
    return '#ffffff';
  };

  const getHoverBackgroundColor = () => {
    if (customColor) return '#000000'; // in case of custom colors, on hover button becomes black with white text
    if (isBlackWithWhiteText) return '#ffffff';
    return '#000000';
  };

  if (!button) return null;

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          '--button-style': style,
          '--button-color': getTextColor(),
          '--button-background-color': getBackgroundColor(),
          '--button-hover-color': getHoverTextColor(),
          '--button-hover-background-color': getHoverBackgroundColor(),
        }}
        className={classNames(className, styles.button, {
          [styles.outlined]: style === 'Outlined',
          [styles.solid]: style === 'Solid',
          [styles.textOnly]: style === 'Text only',
        })}
      >
        {title} <Icon name="arrow" className={styles.icon} />
      </button>
    );
  }

  return (
    <SiteLink
      locale={locale}
      href={addLocaleToHref(link?.slug, locale, router)}
      external={externalLink}
      reloaded={pageReload}
      aria-label={title}
      style={{
        '--button-style': style,
        '--button-color': getTextColor(),
        '--button-background-color': getBackgroundColor(),
        '--button-hover-color': getHoverTextColor(),
        '--button-hover-background-color': getHoverBackgroundColor(),
      }}
      className={classNames(className, styles.button, {
        [styles.outlined]: style === 'Outlined',
        [styles.solid]: style === 'Solid',
        [styles.textOnly]: style === 'Text only',
      })}
    >
      {title}
      {style === 'Text only' && (
        <Icon
          type="arrow"
          width="1.1rem"
          heigth="0.9rem"
          className={styles.icon}
          fill={getTextColor()}
        />
      )}
    </SiteLink>
  );
};

export default Button;
